import { getModulePath, LEAGUE_MODULE_NAMES } from "@leagueplatform/core";
import { useIntl } from "@leagueplatform/locales";
import { UserMenuSection } from "@leagueplatform/solutions-foundation";
import { APP_MANAGED_ROUTES } from "common/app-managed-routes";
import { QUERY_PARAM_MODAL_VALUE } from "common/constants";
import { useUrlParam } from "hooks/use-url-param.hook";

export const useUserMenuConfig = () => {
  const { formatMessage } = useIntl();
  const { setParam } = useUrlParam("modal");

  const userMenu: UserMenuSection[] = [
    {
      heading: formatMessage({ id: "STR_ACCOUNT" }),
      items: [
        {
          label: formatMessage({ id: "STR_MY_PROFILE" }),
          to: getModulePath(LEAGUE_MODULE_NAMES.aboutMe),
        },
        {
          label: formatMessage({ id: "STR_EDIT_PERSONAL_INFORMATION" }),
          to: APP_MANAGED_ROUTES.PERSONAL_INFORMATION,
        },
        {
          label: formatMessage({ id: "STR_DOCUMENTS" }),
          to: getModulePath(LEAGUE_MODULE_NAMES.careDocuments),
        },
      ],
    },
    {
      heading: formatMessage({ id: "STR_SUPPORT" }),
      items: [
        {
          label: formatMessage({ id: "STR_CUSTOMER_SUPPORT" }),
          to: APP_MANAGED_ROUTES.CONTACT_US,
        },
      ],
    },
    {
      heading: formatMessage({ id: "STR_ABOUT" }),
      items: [
        {
          label: formatMessage({ id: "STR_ABOUT_QUEST" }),
          to: APP_MANAGED_ROUTES.ABOUT,
        },
        {
          label: formatMessage({ id: "STR_DELETE_THIS_ACCOUNT" }),
          onClick: () => {
            setParam(QUERY_PARAM_MODAL_VALUE.DELETE_ACCOUNT);
          },
        },
      ],
    },
    {
      items: [
        {
          label: formatMessage({ id: "STR_LOG_OUT" }),
          to: APP_MANAGED_ROUTES.SIGN_OUT,
          variant: "critical",
        },
      ],
    },
  ];

  return { userMenu };
};
